module.exports = "data:image/svg+xml,%3Csvg width='10' height='10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M.897.897a.812.812 0 000 1.149l2.872 2.872L.897 7.791A.813.813 0 102.046 8.94l2.872-2.873L7.791 8.94A.813.813 0 008.94 7.791L6.067 4.918 8.94 2.046A.812.812 0 107.791.896L4.918 3.77 2.046.897a.813.813 0 00-1.15 0z' fill='%23fff'/%3E%3C/svg%3E"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cross.svg
// module id = 73
// module chunks = 1